import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import UserModel from "../models/UserModel";

export interface LoginParam {
    email: string,
    password: string
}

export interface ValidateOtpParam {
    otp: string,
}

export interface LoginResponse {
    is2FactorAuthenticationRequired: boolean,
    user: UserModel,
}

const LoginApi = {
    Login(param: LoginParam) {
        return Api.post<LoginParam, BaseResponse<LoginResponse>>("/api/account/login", param);
    },
    Logout() {
        return Api.post<null, BaseResponse<string>>("/api/account/logout", null);
    },
    ValidateOtp(param: ValidateOtpParam) {
        return Api.post<ValidateOtpParam, BaseResponse<LoginResponse>>("/api/account/ValidateOtp", param);
    },
    GetCurrentUserInfo() {
        return Api.get<null, BaseResponse<UserModel>>("/api/account/GetCurrentUserInfo", null);
    },
};
export default LoginApi;